import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify'
import './plugins/validator'
import Api from '@batimentb/vadimm-js-api'
import VueAWN from 'vue-awesome-notifications'
import 'vue-awesome-notifications/dist/styles/style.css'
import AddressInput from './components/AddressInput'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/fr'
import { currentEnv } from './environments'

// import '@babel/polyfill'

Vue.config.productionTip = false
moment.locale('fr')

require('dotenv').config()

const ENV = currentEnv()
Object.defineProperty(Vue.prototype, '$env', {
  value: ENV
})

const statsApiClient = axios.create({ baseURL: `${ENV.stats}/api` })
Object.defineProperty(Vue.prototype, '$statsApi', {
  value: statsApiClient
})

const billingApiClient = axios.create({ baseURL: `${ENV.billing}/api` })
Object.defineProperty(Vue.prototype, '$billingApi', {
  value: billingApiClient
})

const apiClient = new Api.Client({ host: ENV.api })
Object.defineProperty(Vue.prototype, '$api', {
  value: apiClient
})

const awnOptions = {
  durations: {
    global: 2000
  },
  maxNotifications: 3,
  labels: {
    success: 'OK',
    warning: 'Attention',
    alert: 'Erreur'
  }
}
Vue.component('AddressInput', AddressInput)

Vue.use(VueAWN, awnOptions)

Vue.use(InfiniteLoading)

Vue.filter('prettyPrice', function (value, suffix = '€') {
  if (value) {
    const price = value.toLocaleString()
    return `${price} ${suffix}`
  } else {
    return 'NC'
  }
})

Vue.filter('dtFormat', (value, format) => {
  let d = moment.utc(value, moment.ISO_8601)
  if (value && d.isValid()) {
    d = d.toDate()
    return moment(d).format(format)
  } else {
    return null
  }
})

Vue.filter('booleanLabel', (value) => {
  if (value) {
    return 'Oui'
  } else {
    return 'Non'
  }
})

Vue.filter('truncate', (value, limit = 30) => {
  if (value) {
    return value && value.length && value.length > limit ? value.substring(0, limit) + '...' : value
  }
})

Vue.filter('nullLabel', (value) => {
  if (value) {
    return value
  } else {
    return 'NC'
  }
})

Vue.filter('monthName', function (value) {
  const names = Object.freeze({
    1: 'Janvier',
    2: 'Février',
    3: 'Mars',
    4: 'Avril',
    5: 'Mai',
    6: 'Juin',
    7: 'Juillet',
    8: 'Aout',
    9: 'Septembre',
    10: 'Octobre',
    11: 'Novembre',
    12: 'Décembre'
  })
  return names[parseInt(value)]
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
